export interface PListDto {
  id: number;
  companyNo: string;
  pListID: number;
  description1?: string;
  description2?: string;
  pListDate?: string | null;
  numOfOrderLines?: number;
  weight?: number;
  priority: number;
  pListStatus: number;
  operatorID?: string;
  lockedBy?: string;
  filterGroupID?: string;
  startWorkDateTime?: string | null;
  stopWorkDateTime?: string | null;
  deliveryDate?: string | null;
  statusText: string;
  pListIsBatchYesNo?: boolean;
}

export interface PListLineDto {
  id: number;
  companyNo: string;
  pListID: number;
  pListLineNo: number;
  orderNo: number;
  lineNo: number;
  itemNo?: string;
  itemBarCode?: string;
  qty: number;
  qtyReserved: number;
  qtyPicked: number;
  binCode?: string;
  warehouseID: string;
  lineStatus: number;
  sorting: number;
  isCompleted: boolean;
  remainingQty: number;
  // Order information
  orderNoERP?: string;
  customerName?: string;
  // Package information (for batch picking)
  packageNo?: number;
  visiblePackageNo?: number;
  // Serial/Batch tracking flags (from OrderLine)
  serialNoItemYesNo?: boolean;
  batchItemYesNo?: boolean;
  // Registered serial and batch numbers
  serialNumbers?: OrderSerialNoDto[];
  batchNumbers?: OrderBatchNoDto[];
}

// Serial Number Registration Types
export interface OrderSerialNoDto {
  id: number;
  pListID: number;
  orderNo: number;
  lineNo: number;
  serialNo: string;
  created?: string | null;
  createdBy?: string;
}

export interface CreateOrderSerialNoRequest {
  pListID: number;
  orderNo: number;
  lineNo: number;
  serialNo: string;
}

// Batch Number Registration Types
export interface OrderBatchNoDto {
  id: number;
  pListID: number;
  orderNo: number;
  lineNo: number;
  pListLineNo: number;
  batchNo: string;
  quantity: number;
  quantityGross?: number;
  created?: string | null;
  createdBy?: string;
}

export interface CreateOrderBatchNoRequest {
  pListID: number;
  orderNo: number;
  lineNo: number;
  pListLineNo: number;
  batchNo: string;
  quantity: number;
  quantityGross?: number;
}

export interface UpdateOrderBatchNoRequest {
  quantity: number;
  quantityGross?: number;
}

export interface PListDetailsDto {
  header: PListDto;
  lines: PListLineDto[];
  completedLines: number;
  totalLines: number;
  completionPercentage: number;
}


// OrderSSCC (Pallet Management) Types
export interface OrderSSCCDto {
  id: number;
  companyNo: string;
  pListID: number;
  orderNo: number;
  lineNo: number;
  sscc: string;
  ssccParent?: string;
  gtin?: string;
  quantity: number;
  ssccLevel: number;
  itemBatchNo: string;
  itemBatchExpDate?: string | null;
  stackingWeight?: number;
  grossWeight?: number;
  locationName?: string;
  updatedBy?: string;
  lastUpdate?: string | null;
  createdBy?: string;
  created?: string | null;
}

export interface CreateOrderSSCCRequest {
  companyNo: string;
  pListID: number;
  orderNo: number;
  lineNo: number;
  sscc: string;
  ssccParent?: string;
  gtin?: string;
  quantity: number;
  ssccLevel: number;
  itemBatchNo: string;
  itemBatchExpDate?: string | null;
  stackingWeight?: number;
  grossWeight?: number;
  locationName?: string;
  createdBy?: string;
  created?: string | null;
}

export interface PalletSummaryDto {
  sscc: string;
  ssccParent?: string;
  ssccLevel: number;
  totalItems: number;
  totalQuantity: number;
  totalWeight: number;
  isActive: boolean;
  created?: string | null;
  createdBy?: string;
  items: PalletItemDto[];
}

export interface PalletItemDto {
  orderNo: number;
  lineNo: number;
  gtin?: string;
  quantity: number;
  itemBatchNo: string;
  itemBatchExpDate?: string | null;
  grossWeight?: number;
  locationName?: string;
}

// Discriminated Union Types for Pallet Handling
export interface EmptyPallet {
  type: 'empty';
  sscc: string;
  ssccLevel: number;
  created: string; // ISO timestamp
  createdBy: string;
  items: [];
  totalItems: 0;
  totalQuantity: 0;
  totalWeight: 0;
}

export interface DatabasePallet extends Omit<PalletSummaryDto, 'isActive'> {
  type: 'database';
}

export type UnifiedPallet = EmptyPallet | DatabasePallet;

// Type guard functions
export function isEmptyPallet(pallet: UnifiedPallet): pallet is EmptyPallet {
  return pallet.type === 'empty';
}

export function isDatabasePallet(pallet: UnifiedPallet): pallet is DatabasePallet {
  return pallet.type === 'database';
}
